import { InputHTMLAttributes, useState } from "react";
import PropTypes from "prop-types";
import "react-phone-input-2/lib/high-res.css";
import { twMerge } from "tailwind-merge";

interface CustomInputV2Props extends InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  placeholder?: string;
  containerStyle?: string;
  inputContainerStyle?: string;
  inputTextStyle?: string;
  disabled?: boolean;
  required?: boolean;
}

const CustomInputV2 = ({
  label,
  placeholder,
  containerStyle,
  inputContainerStyle,
  inputTextStyle = "",
  disabled,
  required,
  ...inputProps
}: CustomInputV2Props) => {
  const [isFocused, setIsFocused] = useState(false);

  return (
    <div className={twMerge(`flex flex-col w-full`, containerStyle)}>
      {label && (
        <span className="font-montserrat text-primary font-medium text-xs mb-2">
          {label}
          {required && (
            <span className="font-montserrat font-medium text-xs text-red-500">
              *
            </span>
          )}
        </span>
      )}
      <div
        className={twMerge(
          "rounded-lg px-3 font-montserrat font-medium text-xs flex items-center border",
          inputContainerStyle
        )}
      >
        <input
          {...inputProps}
          disabled={disabled}
          onFocus={(e) => {
            setIsFocused(true);
            inputProps.onFocus?.(e);
          }}
          onBlur={(e) => {
            setIsFocused(false);
            inputProps.onBlur?.(e);
          }}
          className={twMerge(
            "flex-1 bg-transparent outline-none whitespace-pre-wrap break-words overflow-hidden py-2.5",
            inputTextStyle
          )}
          placeholder={placeholder}
          style={{ height: "auto", lineHeight: "1.5" }}
        />
      </div>
    </div>
  );
};

export default CustomInputV2;
